import { deleteData, getData, postData, putData } from 'helpers/apiHelper';
import { MAIN_PATH_MESSAGING, GET_CONVERSATIONS_LIST, GET_CONVERSATION_MESSAGE_HISTORY, INITIATE_CONVERSATION, EDIT_MESSAGE, DELETE_MESSAGE } from './apiPath';
import { conversationList, conversationMessageHistory, handleMessageEdit, handleMessageRemove, initiateClientConversation } from "store/actions/clientMessaging";
import { pickBy } from "lodash";

// Initiate conversation
export function initiateConversation(userId, callback) {
  return (dispatch) => postData(`${MAIN_PATH_MESSAGING}${INITIATE_CONVERSATION}?user_id=${userId}`)
    .then((data) => {
      dispatch(initiateClientConversation(data, callback));
      return data;
    });
}

// Get conversation list
export function getConversationsList(callback) {
  return (dispatch) => getData(`${MAIN_PATH_MESSAGING}${GET_CONVERSATIONS_LIST}`)
    .then((data) => {
      dispatch(conversationList(data, callback));
      return data;
    });
}

// Get converstaion message history
export function getConversationMessageHistory(conversationId, lastMessageId, callback) {
  return (dispatch) => getData(`${MAIN_PATH_MESSAGING}${GET_CONVERSATION_MESSAGE_HISTORY}/${conversationId}`, { params: { lastMessageId } })
    .then((data) => {
      dispatch(conversationMessageHistory(data, conversationId, lastMessageId, callback));
      return data;
    });
}

// Edit message
export function editChatMessage(payload, callback) {
  const { messageId, conversationId, values } = payload;
  return (dispatch) => putData(`${MAIN_PATH_MESSAGING}${EDIT_MESSAGE}/${messageId}`, values)
    .then((data) => {
      const payload = {
        action: "editMessage",
        conversation_id: conversationId,
        message: values?.message,
        message_id: messageId,
        edited_at: new Date(),
      }
      dispatch(handleMessageEdit(payload, callback));
      return data;
    });
}

// Delete message
export function deleteChatMessage(payload, callback) {
  const { messageId, conversationId } = payload;
  return (dispatch) => deleteData(`${MAIN_PATH_MESSAGING}${DELETE_MESSAGE}/${messageId}`)
    .then((data) => {
      const payload = {
        action: "removeMessage",
        conversation_id: conversationId,
        message_id: messageId,
        deleted_at: new Date(),
      }
      dispatch(handleMessageRemove(payload, callback));
      return data;
    });
}